import React from 'react';

import { sanitize } from 'utils/domHelpers';

import * as S from './styles';

export type IconAndTextType = {
  name: string;
  iconUrl: string;
  className?: string;
  // use if text from contentful is returning HTML
  isHTML?: boolean;
};

export const IconAndText = ({
  name,
  iconUrl,
  className,
  isHTML = false,
  ...props
}: IconAndTextType) => {
  return (
    <S.Wrapper className={className} {...props}>
      <S.Icon src={iconUrl} alt={`${name}-icon`} aria-hidden="true" />
      <S.Name>
        {isHTML ? (
          <span
            dangerouslySetInnerHTML={{
              __html: sanitize(name),
            }}
          />
        ) : (
          name
        )}
      </S.Name>
    </S.Wrapper>
  );
};

export default IconAndText;
